// Catálogo completo de ítems del menú lateral.
// Cada ítem tiene: key (identificador único), section (agrupador), label (etiqueta visible).
// Este archivo es la fuente de verdad tanto para Layout (filtrado) como para PerfilesPage (checkboxes).

export const ALL_MENU_ITEMS = [
  // ── MAESTROS ────────────────────────────────────────────────────────
  { key: 'inicio',             section: 'MAESTROS',        label: 'Inicio' },
  { key: 'clientes',           section: 'MAESTROS',        label: 'Clientes' },
  { key: 'proveedores',        section: 'MAESTROS',        label: 'Proveedores' },
  { key: 'familia-productos',  section: 'MAESTROS',        label: 'Familia Productos' },
  { key: 'marcas',             section: 'MAESTROS',        label: 'Marcas' },
  { key: 'almacenes',          section: 'MAESTROS',        label: 'Almacenes' },
  { key: 'productos',          section: 'MAESTROS',        label: 'Productos' },
  // ── INVENTARIOS ─────────────────────────────────────────────────────
  { key: 'movimientos',        section: 'INVENTARIOS',     label: 'Movimientos' },
  { key: 'transferencias',     section: 'INVENTARIOS',     label: 'Transferencias' },
  { key: 'stocks',             section: 'INVENTARIOS',     label: 'Stocks' },
  // ── VENTAS ──────────────────────────────────────────────────────────
  { key: 'cotizaciones',       section: 'VENTAS',          label: 'Cotización' },
  { key: 'ventas',             section: 'VENTAS',          label: 'Ventas' },
  { key: 'cuentas-cobrar',     section: 'VENTAS',          label: 'Cuentas por Cobrar' },
  { key: 'cajas',              section: 'VENTAS/CAJA',     label: 'Gestión Cajas' },
  { key: 'caja-apertura',      section: 'VENTAS/CAJA',     label: 'Apertura / Cierre' },
  { key: 'caja-historial',     section: 'VENTAS/CAJA',     label: 'Historial Cuadres' },
  // ── COMPRAS ─────────────────────────────────────────────────────────
  { key: 'compras',            section: 'COMPRAS',         label: 'Compras' },
  { key: 'cuentas-pagar',      section: 'COMPRAS',         label: 'Cuentas por Pagar' },
  // ── REPORTES ────────────────────────────────────────────────────────
  { key: 'reportes',           section: 'REPORTES',        label: 'Reportes' },
  // ── CONFIGURACION ───────────────────────────────────────────────────
  { key: 'config-unidades',          section: 'CONFIGURACION', label: 'Unidad de Medida' },
  { key: 'config-formas-pago',       section: 'CONFIGURACION', label: 'Forma Pago' },
  { key: 'config-tipos-documento',   section: 'CONFIGURACION', label: 'Tipo Documento' },
  { key: 'config-docs-pago',         section: 'CONFIGURACION', label: 'Documentos Pago' },
  { key: 'config-series-venta',      section: 'CONFIGURACION', label: 'Serie Venta' },
  { key: 'config-tipos-movimiento',  section: 'CONFIGURACION', label: 'Tipo Movimiento' },
  { key: 'config-valores',           section: 'CONFIGURACION', label: 'Valores' },
  // ── SEGURIDAD ───────────────────────────────────────────────────────
  { key: 'usuarios',           section: 'SEGURIDAD',       label: 'Usuarios' },
  { key: 'perfiles',           section: 'SEGURIDAD',       label: 'Perfiles' },
];

export const ALL_KEYS = ALL_MENU_ITEMS.map(i => i.key);

// Agrupado por section para uso en PerfilesPage
export const SECTIONS_ORDER = [
  'MAESTROS', 'INVENTARIOS', 'VENTAS', 'VENTAS/CAJA',
  'COMPRAS', 'REPORTES', 'CONFIGURACION', 'SEGURIDAD',
];

export const SECTION_LABELS = {
  'MAESTROS':       'Maestros',
  'INVENTARIOS':    'Inventarios',
  'VENTAS':         'Ventas',
  'VENTAS/CAJA':    'Ventas — Caja',
  'COMPRAS':        'Compras',
  'REPORTES':       'Reportes',
  'CONFIGURACION':  'Configuración',
  'SEGURIDAD':      'Seguridad',
};
